import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { Grid } from '@mui/system';
import { firmSummaryUrl, homePath } from 'common/config/urls';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { Logo } from 'components';
import { getStringValue } from 'utilities';
import { classes, Root } from './ErrorComponent.styles';
import { ErrorComponentProps } from './types';

const ErrorComponent: React.FC<ErrorComponentProps> = ({ title, subtitle, body }) => {
  const [{ firmList, firmInfo }] = useStore() as unknown as UseStoreValues;

  const homeUrl = useMemo(() => {
    let auxPath = homePath;
    if (firmInfo) {
      auxPath = firmSummaryUrl(getStringValue(firmInfo.slug));
    } else if (firmList?.length) {
      const [defaultFirm] = firmList;
      auxPath = firmSummaryUrl(getStringValue(defaultFirm.slug));
    }
    return auxPath;
  }, [firmList, firmInfo]);

  return (
    <Root className={classes.root}>
      <header className={classes.header}>
        <a href="/">
          <Logo variation="onlyWord" />
        </a>
      </header>
      <main className={classes.main}>
        <div className={classes.container}>
          <Grid container justifyContent="center" alignItems="center" spacing={4}>
            <Grid size={{ lg: 6, xs: 12 }}>
              <div className={classes.content}>
                <Typography className={classes.fontLarge} variant="h1">
                  {title}
                </Typography>
                <div className={classes.margin}>
                  <Typography variant="h1">{subtitle}</Typography>
                </div>
                <div className={classes.margin}>
                  <Typography variant="subtitle2">{body}</Typography>
                </div>
                <div className={classes.margin}>
                  <a href={homeUrl}>Back to Home</a>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </main>
    </Root>
  );
};

export default ErrorComponent;
